import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var sampleCode = "import React from 'react';\nconst HelloWorld = () => {\n  return <div>Hello World!</div>\n};";
export var Context = /*#__PURE__*/React.createContext({
  imageName: 'untitled',
  setImageName: () => {},
  code: sampleCode,
  setCode: () => {},
  lang: 'jsx',
  setLang: () => {},
  panel: undefined,
  setPanel: () => {},
  domImage: undefined,
  setDomImage: () => {},
  theme: 'githubDark',
  setTheme: () => {}
});
export var Provider = _ref => {
  var {
    children
  } = _ref;
  var [imageName, setImageName] = React.useState('untitled');
  var [code, setCode] = React.useState(sampleCode);
  var [lang, setLang] = React.useState('jsx');
  var [panel, setPanel] = React.useState();
  var [theme, setTheme] = React.useState('githubDark');
  var [domImage, setDomImage] = React.useState();
  return /*#__PURE__*/_jsx(Context.Provider, {
    value: {
      imageName,
      setImageName,
      code,
      setCode,
      lang,
      setLang,
      panel,
      setPanel,
      domImage,
      setDomImage,
      theme,
      setTheme
    },
    children: children
  });
};